"use client";
import * as React from "react";
const SvgSendRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m1.151 13.93 14.35-6.171a.826.826 0 0 0 0-1.518L1.15.07A.816.816 0 0 0 .008.82L0 4.625a.82.82 0 0 0 .715.817L12.335 7 .715 8.551A.834.834 0 0 0 0 9.376l.008 3.803c0 .586.6.99 1.143.751Z" }));
export {
  SvgSendRound as default
};
